<template>
  <div>
    <ul class="subscenes-ui">
      <li class="subscenes-li">
        <p>
          子场景
          <el-dropdown @command="subscenesFn" trigger="click">
            <span class="el-dropdown-link">
              <i class="las la-ellipsis-v"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                :command="{
                  type: 'edit',
                }"
                >修改</el-dropdown-item
              >
              <el-dropdown-item
                :command="{
                  type: 'copy',
                }"
                >删除</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </p>
      </li>
      <li class="subscenes-li">
        <p>
          子场景
          <el-dropdown @command="subscenesFn" trigger="click">
            <span class="el-dropdown-link">
              <i class="las la-ellipsis-v"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                :command="{
                  type: 'edit',
                }"
                >修改</el-dropdown-item
              >
              <el-dropdown-item
                :command="{
                  type: 'delete',
                }"
                >删除</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </p>
      </li>
    </ul>
    <ScreenplayModel
      v-if="ifScreenplay"
      :selectedScene="selectedScene"
      :resourceTreeCheck="resourceTreeCheck"
      :close="
        () => {
          ifScreenplay = false;
        }
      "
      ref="screenplayModel"
    >
    </ScreenplayModel>
  </div>
</template>
<script>
//按需加载
const ScreenplayModel = () =>
  import("@/components/tables/program/screenplay/Index.vue");
export default {
  name: "subscenes",
  components: { ScreenplayModel },
  // props: {
  //   getSchemeTree: { type: Function },
  //   selectedScene: { type: Object },
  //   modalNodeData: { type: Array },
  //   close: {
  //     type: Function,
  //   },
  // },
  data() {
    return {
      ifScreenplay: false,
      selectedScene: {
        projectId: 318861441445957,
        pId: 381608071692357,
        name: "新场景标题",
        type: "theEssential",
        sort: 1,
        id: 381608087781445,
        lng: null,
        lat: null,
        alt: null,
        heading: null,
        pitch: null,
        duration: null,
        stop: null,
        treeDataJson: [
          {
            id: 1,
            text: "模型资源",
            key: "model",
            children: [],
          },
          {
            id: 2,
            text: "地形资源",
            key: "terrain",
            children: [],
          },
          {
            id: 3,
            text: "标绘资源",
            key: "vector",
            children: [],
          },
          {
            id: 4,
            text: "文件资源",
            key: "document",
            children: [],
          },
          {
            id: 5,
            text: "矢量资源",
            key: "vectorData",
            children: [],
          },
        ],
        screenplay: [
          {
            projectId: 318861441445957,
            scenesId: 381608087781445,
            name: "显示,交通模拟,模型着色 / 透明",
            sort: 1,
            id: 381951053320261,
            createdTime: "2023-02-03 17:02:50",
            updatedTime: "2023-02-14 18:03:26",
            operate: [
              {
                projectId: 318861441445957,
                methodId: 381951053320261,
                screenplayType: "usually",
                type: "model",
                screenplayId: "dc589eef-10ec-4c33-a298-455d043b466e",
                screenplayName: "晋江枢纽",
                executionProperty: "show",
                property: "add",
                sort: 1,
                id: 385858782978117,
                delay: null,
                delayTime: null,
              },
              {
                projectId: 318861441445957,
                methodId: 381951053320261,
                screenplayType: "usually",
                type: "model",
                screenplayId: "NewNode-fd1d84e7-3966-4f78-8123-4344f1a927df",
                screenplayName: "交通标牌",
                executionProperty: "show",
                property: "add",
                sort: 2,
                id: 385858782978118,
                delay: null,
                delayTime: null,
              },
              {
                projectId: 318861441445957,
                methodId: 381951053320261,
                screenplayType: "usually",
                type: "fixedRoute",
                screenplayId: "381950963290181",
                screenplayName: null,
                executionProperty: "operate",
                property: "start",
                sort: 3,
                id: 385858782978119,
                delay: null,
                delayTime: null,
              },
              {
                projectId: 318861441445957,
                methodId: 381951053320261,
                screenplayType: "usually",
                type: "fixedRoute",
                screenplayId: "381946540134469",
                screenplayName: null,
                executionProperty: "operate",
                property: "start",
                sort: 4,
                id: 385858782978120,
                delay: null,
                delayTime: null,
              },
              {
                projectId: 318861441445957,
                methodId: 381951053320261,
                screenplayType: "usually",
                type: "model",
                screenplayId: "dc589eef-10ec-4c33-a298-455d043b466e",
                screenplayName: "晋江枢纽",
                executionProperty: "overallStaining",
                property: "0.5",
                sort: 5,
                id: 385858782978121,
                delay: null,
                delayTime: null,
              },
              {
                projectId: 318861441445957,
                methodId: 381951053320261,
                screenplayType: "usually",
                type: "model",
                screenplayId: "NewNode-fd1d84e7-3966-4f78-8123-4344f1a927df",
                screenplayName: "交通标牌",
                executionProperty: "overallStaining",
                property: "1",
                sort: 6,
                id: 385858782978122,
                delay: null,
                delayTime: null,
              },
            ],
            operationNameList:
              '[{"value":"show","label":"显示","class":"el-link el-link--primary","type":"usually"},{"value":"fixedRoute","label":"交通模拟","class":"el-link el-link--warning","type":"usually"},{"value":"dyeing","label":"模型着色 / 透明","class":"el-link el-link--warning","type":"usually"}]',
          },
        ],
      },
    };
  },
  computed() {
    //计算属性将被混入到 Vue 实例中。所有 getter 和 setter 的 this 上下文自动地绑定为 Vue 实例。
    //注意如果你为一个计算属性使用了箭头函数，则 this 不会指向这个组件的实例，不过你仍然可以将其实例作为函数的第一个参数来访问。
  },
  watch: {},
  filters: {
    //包含 Vue 实例可用过滤器的哈希表。
  },
  beforeCreate() {
    //在实例初始化之后，数据观测 (data observer) 和 event/watcher 事件配置之前被调用。
  },
  created() {
    //在实例创建完成后被立即调用。在这一步，实例已完成以下的配置：数据观测 (data observer)，property 和方法的运算，watch/event 事件回调。然而，挂载阶段还没开始，el property 目前尚不可用。
  },
  beforeMount() {
    //在挂载开始之前被调用：相关的 render 函数首次被调用。
  },
  methods: {
    subscenesFn(e) {
      console.log(e);
      let { type } = e;
      switch (type) {
        case "edit":
          this.ifScreenplay = true;
          break;
      }
    },
    init() {
      // mapWork.refresh();
    },
  },
  mounted() {
    this.init();
  },
  watch: {
    // modalNodeData: function(newVal, oldVal) {
    //   newVal[0].children.forEach((item) => {
    //     this.checkedIds.push(item.bimModel.embsId);
    //     // this.modalNode.planDemo.content.checkeArr = this.checkedIds;
    //     this.$refs.scenerModel.$refs.modalTree[0].checkChangeArr(
    //       this.checkedIds
    //     );
    //   });
    // },
  },
};
</script>

<style lang="scss" scoped>
.subscenes-ui {
  position: absolute;
  left: 302px;
  padding: 0;
  bottom: 65px;
  transition: all 0.5s;
  list-style: none;
  margin: 0;
  display: flex;
  z-index: 9999;
  .subscenes-li {
    padding: 2px 6px;
    background: rgba(30, 36, 50, 0.6) !important;
    color: #fff;
    cursor: pointer;
    margin-right: 10px;
    position: relative;
    i {
      color: #fff;
    }
    p {
      margin: 0;
      padding: 5px;
      &:before,
      &:after {
        content: "";
        width: 2px;
        height: 0;
        position: absolute;
        transition: all 0.2s linear;
        background: #fff;
        transition-delay: 0s;
      }
      &:after {
        right: -2px;
        bottom: 0;
      }
      &:before {
        left: -2px;
        top: 0;
      }
    }
    &:before {
      content: "";
      width: 0;
      height: 2px;
      position: absolute;
      transition: all 0.2s linear;
      background: #fff;
      transition-delay: 0.2s;
      right: 0;
      top: 0;
    }
    &:after {
      content: "";
      width: 0;
      height: 2px;
      position: absolute;
      transition: all 0.2s linear;
      background: #fff;
      transition-delay: 0.2s;
      left: 0;
      bottom: 0;
    }
    &:hover:before,
    &:hover:after {
      width: 100%;
      transition-delay: 0s;
    }
    &:hover p {
      &:before,
      &:after {
        transition-delay: 0.2s;
        height: 100%;
      }
    }
  }
}

.if-left-fold + div {
  .subscenes-ui {
    left: 20px;
  }
}
</style>
